import React from 'react';
import ServicePageTemplate from '../../components/ServicePageTemplate';
import { Palette } from 'lucide-react';
import { servicePricing } from '../../mockData';

const UIUXDesign = () => {
  const features = [
    {
      title: "User Research",
      description: "Deep understanding of your users' needs, behaviors, and pain points"
    },
    {
      title: "Wireframing",
      description: "Low-fidelity sketches to map out structure and user flows"
    },
    {
      title: "High-Fidelity Mockups",
      description: "Pixel-perfect designs in Figma with your brand colors and style"
    },
    {
      title: "Interactive Prototypes",
      description: "Clickable prototypes to test and validate before development"
    },
    {
      title: "Design Systems",
      description: "Reusable components and style guides for consistency"
    },
    {
      title: "Usability Testing",
      description: "Test with real users and refine based on feedback"
    }
  ];

  const benefits = [
    {
      title: "Improved User Satisfaction",
      description: "Intuitive interfaces that users love lead to higher engagement and retention"
    },
    {
      title: "Reduced Development Cost",
      description: "Catch issues in design phase rather than expensive post-launch fixes"
    },
    {
      title: "Stronger Brand Identity",
      description: "Consistent, beautiful design that reinforces your brand across all touchpoints"
    },
    {
      title: "Competitive Advantage",
      description: "Stand out with superior design that competitors can't easily replicate"
    }
  ];

  const process = [
    {
      title: "Research & Discovery",
      description: "Understand your users, competitors, and business goals through research"
    },
    {
      title: "Information Architecture",
      description: "Organize content and features for optimal user experience"
    },
    {
      title: "Visual Design",
      description: "Create beautiful, on-brand designs that delight users"
    },
    {
      title: "Testing & Iteration",
      description: "Validate designs with users and refine based on feedback"
    }
  ];

  return (
    <ServicePageTemplate
      title="UI/UX Design"
      subtitle="Create Intuitive, Beautiful Interfaces"
      description="User-centered design that combines aesthetics with functionality. We research, design, and test to create experiences that users love and businesses profit from."
      features={features}
      benefits={benefits}
      pricing={servicePricing.uiuxDesign}
      icon={Palette}
      bgColor="#d987ff"
      process={process}
    />
  );
};

export default UIUXDesign;